import { useGetUsersQuery } from '@verantos-dev/data-access-users';
import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useUsersListTable } from '../hooks/useUsersListTable';

export const UsersListTable = () => {
  const { usersTableColumns, onNameCellClick } = useUsersListTable();

  const useUsersDataGridFetch = (searchParams?: string) => {
    return useGetUsersQuery(searchParams || '', {
      pollingInterval: 5000,
    });
  };

  return (
    <DataGridLayout id="users-datagrid-layout">
      <DataGrid
        id="users-list"
        mode="server"
        getRowId={(row) => row.userId}
        columns={usersTableColumns}
        useFetchDataGridData={useUsersDataGridFetch}
        getRowCount={(data) => data.pagination.total}
        pageSizeOptions={[10, 25, 50, 100]}
        initialPageSize={50}
        onCellClick={onNameCellClick}
        pagination
        initialState={{
          sorting: {
            sortModel: [{ field: 'updatedAt', sort: 'desc' }],
          },
        }}
        slotProps={{
          columnHeaders: {
            style: {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              lineHeight: 'normal',
              padding: '16px 24px',
              fontWeight: '500',
              fontSize: '14px',
              color: '#252A36',
            },
          },
        }}
      />
    </DataGridLayout>
  );
};
